export function tryDate(v) {
    if (!v) return null;
    const m = String(v).match(/^(\d{2})[\/\-](\d{2})[\/\-](\d{4})$/) ||
            String(v).match(/^(\d{4})[\/\-](\d{2})[\/\-](\d{2})$/);
    if (!m) return null;
    const [y, mo, d] = m[1].length === 4 ? [m[1], m[2], m[3]]
                                        : [m[3], m[2], m[1]];
    return new Date(+y, +mo - 1, +d);
}

export function tryNumber(v) {
    if (v == null) return null;
    const s = String(v).trim();

    // Si empieza con "0" y es más de un dígito, y no es decimal, lo tratamos como texto
    if (/^0\d+$/.test(s)) {
        return v; // lo devolvemos tal cual, Excel lo verá como texto
    }

    if (s.length > 12) return v; // Strings largas de números (como en tu código original)

    let noMiles;
    const onlyOneCommaAndNoDot = (s.match(/,/g) || []).length === 1 && !s.includes('.');
    if (onlyOneCommaAndNoDot) {
        // no tocar: podría ser decimal (evita el bug)
        noMiles = s;
    } else {
        // aplicar la regex original para quitar separadores de miles
        noMiles = s.replace(/(\d)[.,](?=\d{3}(?:[.,]|$))/g, '$1');
    }
    const norm = noMiles.replace(/,/g, "."); // TODAS las comas

    return /^-?\d+(\.\d+)?$/.test(norm) ? parseFloat(norm) : null;
}